import { runbookVersionConstants } from "../constants/runbookVersion.constants";

export function runbookVersion(state = {}, action) {
  switch (action.type) {
    case runbookVersionConstants.GET_REQUEST:
      return {
        ...state,
        loading: true,
        request: action.payload,
      };
    case runbookVersionConstants.GET_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case runbookVersionConstants.GET_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case runbookVersionConstants.CREATE_REQUEST:
      return {
        ...state,
        creating: true,
        createError: null,
      };
    case runbookVersionConstants.CREATE_SUCCESS:
      return {
        ...state,
        creating: false,
        createSuccess: true,
        createdVersion: action.payload,
        createError: null,
      };
    case runbookVersionConstants.CREATE_FAILURE:
      return {
        ...state,
        creating: false,
        createSuccess: false,
        createError: action.payload,
      };
    default:
      return state;
  }
}
